// import { createTheme, Theme, ThemeOptions } from "@mui/material/styles";
import createTheme from "@mui/material/styles/createTheme";
import type { Theme, ThemeOptions } from "@mui/material/styles";
import { MuiTextFieldVariantsOverridden } from "../modules/mui/TextFields";

export interface ExtraColors {
  white: true;
  blue: true;
  inputFieldBorder: true;
  gray: true;
  red: true;
  green: true;
  "success-2": true;
  "primary-2": true;
  clear: true;
  secondaryColor: true;
  ternaryColor: true;
}

const primaryVar = "#0078D6";
const secondaryVar = "#000000";
const ternaryVar = "#FFFFFF";
const backgroundVar = "#e6e6e6";
const primaryTextVar = "#ffffff";
const secondaryTextVar = "#ffffff";
const ternaryTextVar = "#ffffff";
const backgroundTextVar = "#000000";

const getDefaultPalette = () => ({
  secondaryColor: { main: secondaryVar, contrastText: secondaryTextVar },
  white: { main: "#ffffff" },
  primary: { main: primaryVar, contrastText: primaryTextVar },
  blue: { main: "#2563eb" },
  inputFieldBorder: { main: "#e6e6e6" },
  gray: { main: "#7a7c80" },
  red: { main: "#ff1717" },
  green: { main: "#1a7a67" },
  "success-2": { main: "#33B627" },
  "primary-2": { main: "#DBE7E9" },
  clear: { main: "transparent" },
  ternaryColor: { main: ternaryVar, contrastText: ternaryTextVar },
  backgroundColor: { main: backgroundVar, contrastText: backgroundTextVar },
});

const defaultPalette = getDefaultPalette();

let customTheme: ThemeOptions = {
  components: {
    MuiTextField: {
      variants: MuiTextFieldVariantsOverridden,
    },
    MuiInputLabel: {
      styleOverrides: {
        asterisk: {
          color: "red",
        },
        root: {
          zIndex: "auto",
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        asterisk: {
          color: "red",
        },
        root: {
          zIndex: "auto",
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          color: "black",
        },
      },
    },
  },
  palette: defaultPalette,
};

export const formatTheme = () => {
  return updateTheme(
    primaryVar,
    secondaryVar,
    ternaryVar,
    backgroundVar,
    backgroundTextVar,
    primaryTextVar,
    secondaryTextVar,
    ternaryTextVar
  );
};

export const formatThemeForReservedArea = async () => {
  return updateTheme(
    primaryVar,
    secondaryVar,
    ternaryVar,
    backgroundVar,
    backgroundTextVar,
    primaryTextVar,
    secondaryTextVar,
    ternaryTextVar
  );
};

const updateTheme = (
  bookingPrimaryColor,
  bookingSecondaryColor,
  bookingTernaryColor,
  bookingBackgroundColor,
  backgroundTextColor,
  primaryTextColor,
  secondaryTextColor,
  ternaryTextColor
) => {
  const updatedPalette = {
    ...getDefaultPalette(),
    primary: { main: bookingPrimaryColor, contrastText: primaryTextColor },
    secondaryColor: {
      main: bookingSecondaryColor,
      contrastText: secondaryTextColor,
    },
    ternaryColor: { main: bookingTernaryColor, contrastText: ternaryTextColor },
    backgroundColor: {
      main: bookingBackgroundColor,
      contrastText: backgroundTextColor,
    },
  };

  const updatedTheme: ThemeOptions = {
    components: {
      MuiTextField: {
        variants: MuiTextFieldVariantsOverridden,
      },
      MuiInputLabel: {
        styleOverrides: {
          asterisk: {
            color: "red",
          },
          root: {
            zIndex: "auto",
          },
        },
      },
      MuiFormLabel: {
        styleOverrides: {
          asterisk: {
            color: "red",
          },
          root: {
            zIndex: "auto",
          },
        },
      },
      MuiTypography: {
        styleOverrides: {
          root: {
            color: "black",
          },
        },
      },
    },
    palette: updatedPalette,
  };
  customTheme = { ...customTheme, ...updatedTheme };
  return customTheme;
};

const theme: Theme = createTheme(customTheme);
export default theme;
